import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import LanguageSelector from 'LanguageSelector';
import { Navigate } from 'react-router-dom';

// login routing
const PagesFaqs = Loadable(lazy(() => import('views/pages/saas-pages/Faqs')));
const PageLanding = Loadable(lazy(() => import('views/pages/home')));
const AboutPage = Loadable(lazy(() => import('views/pages/about')));
const ContactPage = Loadable(lazy(() => import('views/pages/contact-us')));
const ServicePage = Loadable(lazy(() => import('views/pages/services')));
const PrivacyPolicy = Loadable(lazy(() => import('views/pages/privacyPolicy')));
const Disclaimer = Loadable(lazy(() => import('views/pages/disclaimer')));
const RefundPolicy = Loadable(lazy(() => import('views/pages/refundPolicy')));
const TermsConditions = Loadable(lazy(() => import('views/pages/termsConditions')));
const ViewCase = Loadable(lazy(() => import('views/pages/home/products/ViewCase')));
const DynamicPages = Loadable(lazy(() => import('views/pages/dynamicPages')));


// ==============================|| AUTH ROUTING ||============================== //

const WebRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <LanguageSelector />
            <MinimalLayout />
        </NavMotion>
    ),
    children: [
        {
            path: '/',
            element: <PageLanding />
        },
        {
            path: '/home',
            element: <PageLanding />
        },
        {
            path: '/about',
            element: <AboutPage />
        },
        {
            path: '/services',
            element: <ServicePage />
        },
        {
            path: '/contact-us',
            element: <ContactPage />
        },
        {
            path: '/faqs',
            element: <PagesFaqs />
        },
        {
            path: '/privacy-policy',
            element: <PrivacyPolicy />
        },
        {
            path: '/disclaimer',
            element: <Disclaimer />
        },
        {
            path: '/refund-policy',
            element: <RefundPolicy />
        },
        {
            path: '/terms-conditions',
            element: <TermsConditions />
        },
        {
            path: '/pages/:slug',
            element: <DynamicPages />
        },
        {
            path: '/case/:id',
            element: <ViewCase />
        },
        {
            path: '/*',
            element: <Navigate to="/" replace />
        }
    ]
};

export default WebRoutes;
